import { useI18n, type StringKey } from "../i18n";
import type { ProfileChange, ProfileField } from "../data";

export const fieldLabel: Record<ProfileField, StringKey> = {
  mobile: "mobile", personal_email: "personalEmail", address: "pfAddress", emergency_contact_name: "pfEmergencyName",
  emergency_contact_phone: "pfEmergencyPhone", marital_status: "pfMarital", education_level: "pfEducation",
};

/** Old → new for each field in a requested change to personal details. */
export function ProfileChangeView({ change, edu }: { change: ProfileChange; edu: { code: string; name_en: string; name_ar: string }[] }) {
  const { t, pick } = useI18n();
  const show = (k: ProfileField, v: string | null | undefined) => {
    if (!v) return <span className="muted">—</span>;
    if (k === "marital_status") return t(`marital_${v}` as StringKey);
    if (k === "education_level") { const e = edu.find((x) => x.code === v); return e ? pick(e.name_en, e.name_ar) : v; }
    return <span dir="auto">{v}</span>;
  };
  return (
    <dl className="change-list">
      {(Object.keys(change.changes) as ProfileField[]).map((k) => (
        <div key={k}>
          <dt>{t(fieldLabel[k])}</dt>
          <dd><s className="muted">{show(k, change.previous[k])}</s> → <strong>{show(k, change.changes[k])}</strong></dd>
        </div>
      ))}
    </dl>
  );
}
